<div class="container-fluid">

  <div class="d-flex justify-content-between align-items-center mb-4">
    <h4 id="upper">Plan d’investissement</h4>
    <div>
      <button routerLink="/suivi/edition/tep-pai" type="button" class="btn btn-primary me-2">TEP/PAI</button>
      <button routerLink="/suivi/edition/pai-stats" type="button" class="btn btn-secondary">PAI</button>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <div class="me-3">
      <label class="d-inline-flex align-items-center">
        Début:
        <input type="date" class="form-control ms-2" [(ngModel)]="dateDebut" name="dateDebut">
      </label>
    </div>

    <div class="me-3">
      <label class="d-inline-flex align-items-center">
        Fin:
        <input type="date" class="form-control ms-2" [(ngModel)]="dateFin" name="dateFin">
      </label>
    </div>


    <!-- Bouton Rechercher -->
    <div class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <input (click)="getStatistique()" type="button" value="Rechercher" class="btn btn-primary">
      </div>
    </div>
    <!-- Bouton Exporter -->
    <div class="dropdown d-inline-block mb-2" ngbDropdown>
      <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton"
        aria-haspopup="true" aria-expanded="false">
        Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format PDF</a>
        <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('excel')">Au format Excel</a>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">

          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive mt-3">
                <!-- <p-accordion multiple="true">
                  <p-accordionTab *ngFor="let programme of paginatedProjets" [header]="programme.libelle"
                    [style]="{ 'border-left': '6px solid #3B82F6' }"
                    headerStyleClass="bg-blue-100 text-blue-800 font-bold">

                    <div class="mb-3">
                      <p class="text-uppercase"><strong>Code:</strong> {{ programme.code }}</p>
                      <p class="text-uppercase"><strong>Coût:</strong> {{ programme.cout | formatMoney:null }} FCFA</p>
                    </div>

                    <p-accordion multiple="true">
                      <p-accordionTab *ngFor="let action of programme.actions" [header]="action.libelle"
                        [style]="{ 'border-left': '6px solid #22C55E' }"
                        headerStyleClass="bg-green-100 text-green-800 font-semibold">

                        <p class="text-uppercase"><strong>Montant:</strong> {{ action.montant | formatMoney:null}} FCFA</p>
                        <p class="text-uppercase"><strong>Poids:</strong> {{ action.poids }}%</p>

                        <p-accordion multiple="true">
                          <p-accordionTab *ngFor="let ptAction of action.pt_actions" [header]="ptAction.libelle"
                            [style]="{ 'border-left': '6px solid #F59E0B' }"
                            headerStyleClass="bg-yellow-100 text-yellow-800 font-medium">

                            <p class="text-uppercase"><strong>Année:</strong> {{ ptAction.annee }}</p>
                            <p class="text-uppercase"><strong>Montant Total:</strong> {{ ptAction.montant_total_action | formatMoney:null }}</p>

                            <p-panel *ngFor="let activite of ptAction.pta_activites"
                              header="{{ activite.code_activite }} - {{ activite.activite }}"
                              [style]="{ 'border-left': '4px solid #8B5CF6', 'margin-bottom': '1rem' }"
                              headerStyleClass="bg-purple-100 text-purple-800 font-medium">

                              <p class="text-uppercase"><strong>Localisation:</strong> {{ activite.localisation }}</p>
                              <p class="text-uppercase"><strong>TEP:</strong> {{ activite.tep_realise }} / {{ activite.tep_prevu }}</p>

                              <ul class="mt-2">
                                <li *ngFor="let tache of activite.pta_taches" class="mb-2">
                                  <i class="pi"
                                    [ngClass]="tache.est_realise ? 'pi-check-circle text-green  ' : 'pi-circle text-gray-500'"></i>
                                  <strong>{{ tache.code }}</strong>: {{ tache.libelle }}
                                  <small class="block text-gray-500">
                                    {{ tache.date_debut | dateFormat }} - {{ tache.date_fin  | dateFormat }}
                                  </small>
                                </li>
                              </ul>

                            </p-panel>

                          </p-accordionTab>
                        </p-accordion>

                      </p-accordionTab>
                    </p-accordion>

                  </p-accordionTab>
                </p-accordion> -->
                <table class="table table-centered datatable dt-responsive nowrap"
                  style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                  <thead class="thead-light rwd-table">
                    <tr>
                      <th>Code</th>
                      <th>Activités</th>
                      <th>Anputation budgétaire</th>
                      <th>Tep Prévu(%)</th>
                      <th>Tep Réaliser(%)</th>
                      <th>Montant Engagé</th>
                      <th>% Engagement</th>
                      <th>Montant ordonnancé</th>
                      <th>% Ordonnancé</th>
                      <!-- <th>Anputation budgétaire</th> -->
                      <!-- <th>Montant Décaissé</th> -->
                      <!-- <th>% Décaissement</th> -->
                      <!-- <th>Commentaires</th> -->

                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of paginatedProjets; let index = index">
                      <td>{{item.code_activite || '-'}}</td>
                      <td>{{item.activite || '-'}}</td>
                      <td>{{item.amputation_budgetaire | formatMoney:null || '-'}}</td>
                       <td>{{ item.tep_prevu }}</td>
                      <td>{{ item.tep_realise }}</td>
                      <td>{{item.total_engage | formatMoney:null}}</td>
                      <td>{{item.montant_decaisse | formatMoney:null}}</td>
                      <td>{{item.total_ordonnance | formatMoney:null}}</td>
                      <td>{{item.montant_decaisse | formatMoney:null}}</td>
                     
                    </tr>

                    <tr *ngIf="paginatedProjets.length === 0 && isLoading === false">
                      <td colspan="10" class="text-center">
                        <h5 id="graycolor">Aucune donnée trouvée</h5>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-center" *ngIf="isLoading === true">
                <div class="container">
                  <div class="row">
                    <div class="text-center">
                      <h5 id="graycolor">Chargement en cours</h5>
                      <div class="loader4"></div>
                    </div>
                  </div>
                </div>
              </div>
              <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
                [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
              </p-paginator>
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>


</div>

<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>